import React from 'react';
import { Image } from '@thd-olt-component-react/core-ui';
import { generateImageSource } from '../../../../utils/generateImageSource';

const ProTip = ({ paragraphDetails }) => {
  return (
    <div className="create-job-posting__tooltip-section" data-testid="pro-tip-paragraph">
      <div className="create-job-posting__tip-label">
        <p>
          <Image
            src={generateImageSource('/images/v1/path-to-pro/light-bulb-orange.svg')}
            alt="trade icon"
            data-testid="tradeTypeIcon"
          />
          <span style={{ paddingLeft: '10px' }}>
              Pro Tip:
          </span>
        </p>
      </div>
      <p>{paragraphDetails}</p>
    </div>
  );
};
export default ProTip;